import { useMemo, useState } from 'react';
import { gamesStoreActions } from '../../../store';
import { useGetLoadFeedCategoryCallback } from '../../useGetLoadFeedCategoryCallback';
import { useGetLoadFeedGamesCallback } from '../../useGetLoadFeedGamesCallback';
import { useGetLoadFeedProviderGamesCallback } from './useGetLoadFeedProviderGamesCallback';

const { PLEX_SET_PAGINATION } = gamesStoreActions;

export const usePlexPaginationLoadGames = ({
  isCustomCategory,
  entity,
  entityId,
  paginationGamesIds,
  casinoType,
  feedName
}) => {
  const [isLoading, setIsLoading] = useState(false);

  const loadCustomCategory = useGetLoadFeedGamesCallback();
  const loadProviderGames = useGetLoadFeedProviderGamesCallback();
  const loadCategory = useGetLoadFeedCategoryCallback(casinoType);

  const loadFunction = useMemo(() => {
    // loadCategory for empty search (popular, from config casinoSearchBottomCategory)
    if (entity === 'search') {
      return loadCategory;
    }
    if (entity === 'category') {
      return isCustomCategory ? loadCustomCategory : loadCategory;
    }
    return loadProviderGames;
  }, [
    entity,
    isCustomCategory,
    loadCategory,
    loadCustomCategory,
    loadProviderGames
  ]);

  const loadGames = async ({
    offset,
    limit,
    id,
    launchId,
    isInitialCall = false,
    dontUseGamesStorage = false
  }) => {
    if (isCustomCategory && !id?.length && !launchId?.length) {
      return;
    }
    setIsLoading(true);

    const res = await loadFunction({
      feedName,
      filter: { offset, limit, id, launchId },
      id: entityId,
      dontUseGamesStorage
    });
    const nextGamesIds = (isCustomCategory ? res.gamesIds : res) || [];
    const prevGamesIds = isInitialCall ? [] : paginationGamesIds || [];

    PLEX_SET_PAGINATION({
      entity,
      pagination: {
        id: entityId,
        gamesIds: [...prevGamesIds, ...nextGamesIds]
      }
    });

    setIsLoading(false);
  };

  return { loadGames, isLoading, setIsLoading };
};
